import React from "react";
import { Container } from "@mui/material";
import { SmileySad } from "@phosphor-icons/react";
import { stormGrey } from "../../theme/colors";

export const NoGrades = () => (
  <Container style={styles.container}>
    <div style={styles.row}>
      <div style={styles.iconContainer}>
        <SmileySad size={32} />
      </div>
    </div>
    <h4 style={styles.heading}>No Grading Model Available</h4>
    <div style={styles.row}>
      <p style={styles.text}>
        We're sorry, but there are currently no Grading Model available for you
        to view. Please check back later or create a new grading model.
      </p>
    </div>
  </Container>
);

const styles = {
  container: {
    marginTop: "5rem",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  heading: {
    fontSize: "1.65rem",
    fontWeight: "500",
    marginTop: "1rem",
    marginBottom: "0",
    textAlign: "center",
  },
  iconContainer: {
    backgroundColor: stormGrey[100],
    padding: "1rem",
    borderRadius: "50%",
    height: "40px",
    width: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    color: stormGrey[400],
    fontSize: "1rem",
    textAlign: "center",
    width: "50%",
  },
};
